import plasiyoLogo from '../assets/logo.png';
import aryaLogo from '../assets/ary.png';

export interface TenantConfig {
  name: string;
  slogan: string;
  firmId: number | null;
  logo: string;
  features: {
    enableDealershipForm: boolean;
  };
}

const configs: Record<string, TenantConfig> = {
  plasiyo: {
    name: "Plasiyo",
    slogan: "İşletmenizin Dijital Gücü",
    firmId: null,
    logo: plasiyoLogo,
    features: {
      enableDealershipForm: true,
    },
  },
  arya: {
    name: "Arya Perde",
    slogan: "Güvenilir B2B Partneriniz",
    firmId: 7,
    logo: aryaLogo,
    features: {
      enableDealershipForm: false,
    },
  },
};

const currentTenant = process.env.REACT_APP_TENANT || "plasiyo";

export const tenantConfig = configs[currentTenant];
